import Nonlocal from "./Nonlocal";

const CurrentProjects = ()=>{
    return(
        <>
        <Nonlocal/>
        </>
    )
}
export default CurrentProjects;